import { queryClient } from "@/services/react-query/queryClient";
import { supabase } from "@/services/supabase/createClient";

export const renameResource = async (resourceId: string, name: string) => {
  const { error } = await supabase.from("resources").update({ name }).eq("resource_id", resourceId);

  queryClient.invalidateQueries({
    queryKey: ["resources", resourceId],
  });

  return { error };
};
